import { type TElementType, type TSettings } from '@accure/siteview';

import { AssetType } from '@/siteview/entities/asset-type';
import type { AssetsFilters } from '@/siteview/entities/assets-filters';
import type { Settings } from '@/siteview/entities/settings';
import {
  type ViewFilters,
  ViewFiltersMode,
} from '@/siteview/entities/view-filters';

export function getSiteviewSettings(
  assetsFilters: AssetsFilters,
  viewFilters: ViewFilters,
  settings: Settings,
): TSettings {
  return {
    // We use textures only in realistic view mode.
    useTextures: viewFilters.viewMode === ViewFiltersMode.REALISTIC,
    elementTypeToHover: elementTypesFromAssetType[assetsFilters.assetType],
    elementTypeToClick: elementTypesFromAssetType[assetsFilters.assetType],

    mapType: settings.mapType,
    rackVisualizationMode: 'block',

    // View mode
    viewMode: settings.viewMode,
    fovForBirdsEyeView: settings.fovForBirdsEyeView,
    fovForPOVView: settings.fovForPOVView,
    elevationForPOVView: 1.75,
  };
}

const elementTypesFromAssetType: Record<AssetType, TElementType[]> = {
  [AssetType.CONTAINER]: ['container', 'pcs'],
  [AssetType.STRING]: ['string', 'pcs'],
  [AssetType.RACK]: ['rack', 'pcs'],
  [AssetType.MODULE]: ['module', 'pcs'],
  [AssetType.PCS]: ['pcs'],
};
